import React from "react";
import PropTypes from "prop-types";
import { Provider } from "react-redux";
import createStore from "../state/createStore";
import "aos/dist/aos.css"; // You can also use <link> for styles
import $ from "jquery";
import ContentPage from "../components/content-page";
import Meta from "../components/meta";
import "animate.css/animate.min.css";
import HeroSection from "../components/homeSection";
import KeyInitiatives from "../components/KeyInitiatives";
import About from "../components/about";
import Vision from "../components/vision";
import Partners from "../components/partners";
import Teams from "../components/team";
import Connect from "../components/ConnectComponent";
import OverView from "../components/overView";
import NewFooter from "../components/NewFooter";
import Point from "../components/ManifestoPoint";
import ReactPixel from "react-facebook-pixel";

const store = createStore();

export class HomeView extends React.Component {
  constructor(args) {
    super(args);
    this.state = {
      isShowSidebar: false,
      isAboutActive: false,
      activeRouteName: "",
      appLoader: false,
    };
  }
  componentDidMount() {
    ReactPixel.init("2879175222167037");
    ReactPixel.track("ViewContent", location);

    const { setFunc } = this;
    const { isAboutActive } = this.state;
    let hash = window.location.hash;
  }
  setFunc = () => {
    // // console.log("setFunc", this.state.isAboutActive)
    if (!this.state.isAboutActive) {
      this.setState({
        isAboutActive: true,
      });
    }
  };
  handleScroll = (item) => {};
  getActiveRoute = (name) => {
    this.setState({
      activeRouteName: name,
    });
  };

  render() {
    const { location } = this.props;
    const { appLoader } = this.state;

    let route = location.pathname.split("/")[1];
    let activeRoute = location.hash;
    return (
      <Provider store={store}>
        <ContentPage>
          <Meta
            title={"Winpe | Diversity is Now"}
            description={
              "Winpe is a pioneering platform founded in 2020 dedicated to creating a culture of growth and advancing gender diversity in private equity."
            }
            image={
              "https://winpeforum.com/assets/elements/WinPE_Home_Page_link_image1.jpg"
            }
            keywords="Winpe Development Forum,Winpe India,Winpe gender diversity,diversity and inclusion,Winpe private equity,Winpe venture capital,gender diversity India,gender diversity private equity,gender diversity venture capital,Nupur Garg Winpe,Winpe Diversity is Now,Diversity is Now,Glass Ceilings Finance,Women in private equity,gender diversity platform,gender balance private equity,gender balance investing ecosystem,gender diversity investing,women in investing,gender parity investing,gender parity finance,women capital allocators,women investors,investment capital women,diversity in boardrooms,engage empower enhance,resources women private equity,platform women venture capital,female talent investing,Winpe Founding Members,Winpe Partners ,Winpe Associate Partner,Winpe Knowledge Partners,Winpe Advisory Board,Anita George CDPQ,Renuka Ramnath Multiples Alternate Asset Management,Zia J. Mody AZB & Partners,Ester Martinez People Matters,Matangi Gowrishankar ,Shyamala Gopinath,Winpe Ignite,Winpe ProClub,Winpe Insights,Winpe Shine,Winpe Collegium,Winpe Parleys,Winpe Edge,training resources women private equity,networking resources women private equity,mentoring resources women private equity,mentoring resources gender diversity,mentoring platform investing"
            location={location}
          />
          {appLoader ? (
            <i className="fa fa-spin fa-spinner"></i>
          ) : (
            <div className="page-layout__viewport">
              <div className="page-layout__viewport__left_content"></div>
              <div className="page-layout__viewport__middle_content">
                <div id="fullscreen" className="fullscreen">
                  <div id="#" className="section main__wrapper">
                    <HeroSection />
                  </div>
                  <div id="about">
                    <div id="overview" className="section main__wrapper">
                      <OverView />
                    </div>
                    <div id="" className="section main__wrapper">
                      <About />
                    </div>
                    <div
                      ref="#vision"
                      id="vision"
                      className="section main__wrapper"
                    >
                      <Vision />
                    </div>
                    {/* <div
                      id="winpemanifesto"
                      ref="#winpemanifesto"
                      className="section main__wrapper"
                    >
                      <Point />
                    </div> */}
                  </div>
                  <div id="initiatives" className="section main__wrapper">
                    <KeyInitiatives />
                  </div>
                  <div id="/events"></div>
                  
                  <div id="team" className="section main__wrapper">
                    <Teams />
                  </div>
                  <div id="/ambassadors"></div>
                  <div
                    ref="#partners"
                    id="partners"
                    className="section main__wrapper"
                  >
                    <Partners />
                  </div>
                  <div
                    ref="#connect"
                    id="connect"
                    className="section main__wrapper sub_section"
                    style={{ width: "100%" }}
                  >
                    <Connect />
                  </div>
                  <div id="/knowledge"></div>
                  <div id="/connect"></div>
                  <div id="/insights"></div>
                </div>
                {/* appChildren */}
              </div>
            </div>
          )}
        </ContentPage>
      </Provider>
    );
  }
}
HomeView.propTypes = {
  location: PropTypes.object,
};

export default HomeView;



// WEBPACK FOOTER //
// ./src/components/HomeView.js